import { render, staticRenderFns } from "./LandingVideo.vue?vue&type=template&id=2956f3d8"
import script from "./LandingVideo.vue?vue&type=script&lang=js"
export * from "./LandingVideo.vue?vue&type=script&lang=js"
import style0 from "./LandingVideo.vue?vue&type=style&index=0&id=2956f3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports